import { bool, func } from 'prop-types';
import Modal from '../../shared/Modal';
import Button from '../../shared/Button';
import Select from '../../shared/Select';
import { Box, Cluster, Stack } from '../../shared/layouts';
import {useTranslation} from "react-i18next";

const GetDataModal = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <Stack space="l">
        <Box fontScale="xl" fontWeight="bold">
          {t('Van wie wil je gegevens ophalen?') + ' '}
        </Box>
        <Select
          name="data"
          value="value1"
          options={[{ value: 'value1', label: 'label 1' }]}
          onChange={() => {}}
        />
      </Stack>
      <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
        <Button variant="secondary" onClick={onRequestClose}>
          {t('Annuleren')}
        </Button>
        <Button>{t('Gegevens ophalen')}</Button>
      </Cluster>
    </Modal>
  );
}

GetDataModal.propTypes = {
  isOpen: bool,
  onRequestClose: func,
};

GetDataModal.defaultProps = {
  isOpen: false,
  onRequestClose: () => {},
};

export default GetDataModal;
